import { Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: '[grid-item]'
})
export class GridItemDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
